<template>
    <div
        v-if="goBack"
        class="ui-back-button"
        @click="router.back()"
    >
        <span class="ui-back-button__icon">
            <img v-svg-inline src="@/assets/icons/ui/back-arrow.svg" />
        </span>

        <span class="ui-back-button__text">{{ text }}</span>
    </div>

    <router-link
        v-else
        class="ui-back-button"
        :to="to"
    >
        <span class="ui-back-button__icon">
            <img v-svg-inline src="@/assets/icons/ui/back-arrow.svg" />
        </span>

        <span class="ui-back-button__text">{{ text }}</span>
    </router-link>
</template>

<script lang="ts" setup>
    import { defineProps } from 'vue';
    import { useRouter } from 'vue-router';

    defineProps({
        text: {
            type: String,
            default: 'Назад',
        },
        to: {
            type: String,
            default: '',
        },
        goBack: {
            type: Boolean,
            default: false,
        },
    });

    const router = useRouter();
</script>

<style scoped lang="scss">
    @use './UIBackButton.scss' as *;
</style>
